var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFMiconShopnow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Untitled 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FMicon_shopnow",
    transform: "translate(2.0791, 29.11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.2548162,20.3211468 C93.0196653,18.8659128 91.4526025,17.7291226 89.6858531,17.006696 L90.4717538,14.6441125 C90.4717538,14.6441125 74.7098074,0.458848859 52.3287221,0 C52.3287221,0 44.6063934,1.57668278 40.3498381,3.62685853 C36.0932827,5.67703429 23.9777203,12.4377329 21.9958837,16.2207953 L23.6409057,17.006696 C23.6409057,17.006696 18.735128,18.1098858 17.090106,17.6217487 C15.445084,17.1336116 4.60355942,8.83528122 0.883954837,8.9719596 C0.883954837,8.9719596 1.79188981,11.017254 1.52829579,12.755022 C1.26470176,14.49279 -0.336387873,20.6335545 0.0638845361,22.3664412 C0.464156945,24.0993278 2.07989069,29.932566 2.06036521,31.9827417 L2.06036521,34.0329175 C2.06036521,34.0329175 2.21168771,34.5210546 4.18864289,33.2421354 C6.16559808,31.9632163 12.2477861,28.1996793 12.9751104,28.0434755 C13.7024347,27.8872716 15.4157958,25.4221793 17.9541087,25.3928911 C20.4924215,25.3636029 22.3863934,25.1097716 23.1722941,25.7101802 L21.2734408,26.6229966 C21.2734408,26.6229966 29.1568547,32.314675 31.8367273,34.1207822 C34.5165999,35.9268894 41.2333662,41.2817532 48.4333882,41.3891433 C55.6334102,41.4965335 73.3918373,36.1319069 74.4462134,34.9799034 L74.6561123,32.8760326 L76.4378127,32.3488445 C76.1538859,33.0258151 75.9427986,33.7310755 75.8081158,34.4527154 C75.8081158,34.9799034 76.4378127,38.7580845 77.0723909,38.4456767 C77.7069691,38.133269 79.9084673,34.9799034 78.1218856,32.1389456 C78.1218856,32.1389456 81.7975579,30.9869421 83.7940385,30.7721618 C85.7905192,30.5573815 90.7304665,27.9360853 91.7799612,27.3063885 C92.829456,26.6766916 95.0260728,25.1000089 95.9779401,24.680211 C95.9779401,24.680211 96.1976018,21.9466433 95.2506159,22.3664412 C94.3036299,22.7862391 91.9898602,23.943124 90.8573821,24.0505141 C90.842738,24.0505141 93.4689155,20.4773507 94.2548162,20.3211468 Z",
    id: "Path",
    stroke: "#173050",
    strokeWidth: 2.17,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7288846,26.0714016 C13.0336869,21.2876582 16.7288846,17.006696 16.7288846,17.006696 L9.22133623,12.7403779 L2.49480721,9.25507911 L0.883954837,8.9719596 C1.41643267,11.0727743 1.45319718,13.2686184 0.991344995,15.3860809 C0.545646576,17.6925104 0.23757585,20.0234159 0.0687659069,22.3664412 L1.59663498,28.7122233 L2.05548384,33.1689148 C2.05548384,33.1689148 1.7772457,34.7163094 3.69074307,33.5154922 C5.60424044,32.314675 9.63137138,29.8495827 9.63137138,29.8495827 L16.7288846,26.0714016 Z",
    id: "Path",
    fill: "#173050",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9614814,17.006696 C78.9614814,17.006696 75.4029621,20.7263006 75.4517758,24.1286161 C75.5005895,27.5309315 77.7118505,28.9074781 79.9328742,29.6348024 C82.1538979,30.3621266 83.7989199,30.7721618 83.7989199,30.7721618",
    id: "Path",
    stroke: "#173050",
    strokeWidth: 2.17,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#173050",
    strokeWidth: 2.17,
    cx: 87.9383224,
    cy: 19.2228384,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#173050",
    strokeWidth: 2.17,
    cx: 87.367202,
    cy: 23.0937654,
    r: 1.02508788
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-10.4555, -29.7275)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7922282,17.4948331 C23.7922282,17.4948331 53.3782168,-0.0488137084 89.842057,17.6217487 L90.4717538,14.6489939 L77.4873074,6.32137524 C77.4873074,6.32137524 65.9575095,1.12759666 59.1431158,0.536950792 C52.3287221,-0.0536950792 50.7910903,0.151322496 47.4278258,1.14224078 C44.0645613,2.13315906 35.9614857,5.90645871 35.9614857,5.90645871 L26.198744,12.0667487 L22.9331069,14.9467575 L21.9958837,16.2207953 L23.7922282,17.4948331 Z",
    id: "Path",
    fill: "#173050",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6116175,25.4905185 C23.6116175,25.4905185 48.6042362,40.3152418 74.4218065,32.4269465 L74.5487222,33.9938665 C74.5487222,33.9938665 75.1833004,35.0628867 71.7419339,36.2051275 C68.3005675,37.3473683 52.3482476,41.0864983 52.3482476,41.0864983 L46.2758223,41.0864983 L38.953766,38.6458129 L29.1129224,32.2268103 L21.2734408,26.6229966 L23.6116175,25.4905185 Z",
    id: "Path",
    fill: "#173050",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9447942,17.006696 C75.9447942,17.006696 72.8158355,13.9119069 69.6819954,15.7619464 C66.5481554,17.611986 68.2175842,21.653761 64.6981158,21.4829131 C61.1786474,21.3120651 16.7093591,21.4829131 16.7093591,21.4829131",
    id: "Path",
    stroke: "#173050",
    strokeWidth: 2.17,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFMiconShopnow);
export default __webpack_public_path__ + "static/media/FMicon_shopnow.473eb91f43280046d66568ac795a7551.svg";
export { ForwardRef as ReactComponent };